var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProfessionalBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30588_16848)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2498 27.5H18.7499H11.2498H1.25004C0.559688 27.5 0 28.0596 0 28.7499V51.2499C0 53.321 1.67895 54.9999 3.75 54.9999H56.25C58.3211 54.9999 60 53.321 60 51.2499V28.7499C60 28.0596 59.4403 27.5 58.75 27.5H48.7499H41.2498ZM41.2498 27.5C40.5594 27.5 39.9998 28.0597 39.9998 28.75V36.25C39.9998 36.9404 40.5594 37.5001 41.2498 37.5001H48.7498C49.4401 37.5001 49.9998 36.9404 49.9998 36.25V28.75C50 28.0596 49.4403 27.5 48.7499 27.5C48.0596 27.5 47.4999 28.0597 47.4999 28.75H42.4998C42.4998 28.0597 41.9401 27.5 41.2498 27.5ZM11.2498 27.5C11.9401 27.5 12.4998 28.0597 12.4998 28.75H17.4999C17.4999 28.0597 18.0596 27.5 18.7499 27.5C19.4403 27.5 20 28.0596 20 28.7499V36.2499C20 36.9403 19.4403 37.5 18.7499 37.5H11.2499C10.5596 37.5 9.99987 36.9403 9.99976 36.25V28.75C9.99976 28.0597 10.5594 27.5 11.2498 27.5Z",
    fill: "#4FB5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75 15H21.25C20.5596 15 19.9999 14.4403 19.9999 13.7499V8.75C19.9999 6.67895 21.6789 5 23.7499 5H36.25C38.321 5 40 6.67895 40 8.75V13.75C40 14.4403 39.4404 15 38.75 15ZM22.5 12.5H37.5V8.75C37.5 8.05965 36.9403 7.49996 36.25 7.49996H23.75C23.0597 7.49996 22.5 8.05965 22.5 8.75V12.5Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25 12.5H3.75C1.67895 12.5 0 14.1789 0 16.25V28.75C0 29.4403 0.559688 30 1.25004 30H58.7501C59.4404 30 60.0001 29.4403 60.0001 28.7499V16.25C60 14.1789 58.3211 12.5 56.25 12.5Z",
    fill: "#2B71F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30588_16848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfessionalBrand);
export default __webpack_public_path__ + "static/media/my-professional-brand.287850606b9451e1a678b7f8a97760f8.svg";
export { ForwardRef as ReactComponent };